import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { useHistory } from 'react-router-dom';
import { Select } from '@insurancemenu/imenu-components-lib';
import { Search, Help } from '@insurancemenu/imenu-components-lib/dist/icons';
import { toJS } from 'mobx';
import { StandardFormChangeEvent } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import {
  ActionBarStyled,
  FiltersWrapperStyled,
  ButtonsWrapperStyled,
  BrowseButtonStyled,
  HelpButtonStyled,
} from './styles';

const BrowsingCriteriaFilters: React.FC = () => {
  const {
    popularPlansStore: { getBrowsingCriteriaFilters, getFilterValue, onFilterChange },
  } = useRootStore();
  const filters = getBrowsingCriteriaFilters();
  return Object.keys(filters).map((key) => (
    <Select
      key={key}
      label="Subcategory"
      name={key}
      options={filters[key]}
      value={getFilterValue(key, filters[key])}
      onChange={(e: StandardFormChangeEvent): Promise<void> => onFilterChange(key, e.target.value)}
      width="25rem"
    />
  ));
};

const PopularPlansActionBar: React.FC = observer(() => {
  const {
    popularPlansStore: {
      productLines,
      currentProductLineId,
      loading,
      allPortfolios,
      cart,
      domainConfig,
      onProductLineChange,
    },
    domainStore: { getProductLineOptions },
  } = useRootStore();

  const history = useHistory();
  const convertedPLines = productLines.map((pLine) => toJS(pLine)).slice();
  const convertedCart = toJS(cart);
  const portfoliosQuantity = allPortfolios.length;

  const isBrowseAllHidden = domainConfig[cart.rateSegment]?.eStoreHideBrowseAll;
  const showBrowseAllButton = !loading && portfoliosQuantity > 0 && !isBrowseAllHidden;

  const currentPLineId = currentProductLineId || convertedPLines[0]?.productLineId;
  const showHelpMeDecideButton =
    convertedPLines.find((pLine) => pLine.productLineId === currentPLineId)?.eStoreHelpMeDecide || false;

  const handleBrowseClick = (): void => {
    history.push(
      `/browsing?groupId=${convertedCart.groupId}&cartId=${convertedCart.id}&productLineId=${currentProductLineId}&cartType=browsing&backType=popular`,
    );
  };

  const handleHelpMeDecideClick = (): void => {
    history.push(
      `/help-me-decide?groupId=${convertedCart.groupId}&cartId=${convertedCart.id}&productLineId=${currentProductLineId}&cartType=help-me-decide`,
    );
  };

  return (
    <ActionBarStyled>
      <FiltersWrapperStyled>
        <Select
          label="Product line"
          name="productLine"
          options={getProductLineOptions(convertedPLines)}
          value={currentProductLineId || convertedPLines[0]?.productLineId}
          onChange={onProductLineChange}
          width="25rem"
        />
        <BrowsingCriteriaFilters />
      </FiltersWrapperStyled>
      {(showBrowseAllButton || showHelpMeDecideButton) && (
        <ButtonsWrapperStyled>
          {showBrowseAllButton && (
            <BrowseButtonStyled
              leftIconProp={<Search />}
              size="large"
              type="outlined"
              color="primary"
              onClick={handleBrowseClick}
            >
              Browse all plans
            </BrowseButtonStyled>
          )}
          {showHelpMeDecideButton && (
            <HelpButtonStyled color="primary" size="large" leftIconProp={<Help />} onClick={handleHelpMeDecideClick}>
              Help me decide
            </HelpButtonStyled>
          )}
        </ButtonsWrapperStyled>
      )}
    </ActionBarStyled>
  );
});

export default PopularPlansActionBar;
